import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePreviousPath } from '../../hooks/usePreviousPath';
import './Header.css';

const iconMap = {
  home: '/home.svg',
  myPage: '/my.svg',
  logo: 'https://cdn.cokeplay.cocacola.co.kr/resources/images/logo_CokePLAY.svg',
  back: '/back.svg',
  alarm: '/alarm.svg',
  cart: '/icon_cart.svg',
};

const Header = ({ useLogo, left, title, rightIcon1, rightIcon2, modalOpen }) => {
  const navigate = useNavigate();
  const prevPath = usePreviousPath();
  const { profile, logOut} = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  
  const handleIconClick = (icon) => {
    if (icon === 'back') {
      prevPath ? navigate(prevPath) : navigate('/store');
    } else if (icon === 'home') {
      navigate('/home');
    }
  };

  const handleMyPage = () => {
    setIsOpen(true);
    setTimeout(()=>{
      setIsOpen(false);
    }, 2000);
  };

  return (
    <div className="header-container">
      <div className="header">
        {useLogo && <img id="header-logo" src={iconMap['logo']} alt="logo" />}
        {left && (
          <img
            id="header-left-icon"
            src={iconMap[left]}
            alt="left-icon"
            onClick={()=>handleIconClick(left)}
            style={{ cursor: 'pointer' }}
          />
        )}
        {title && <div id="header-title">{title}</div>}
        <div className="header-right-icons">
        <img className="header-right-icon" src="/header_search.svg" onClick={modalOpen} style={{ cursor: 'pointer' }} alt="my" />
          {rightIcon1 && <img className="header-right-icon" src={iconMap[rightIcon1]} onClick={()=>handleIconClick(rightIcon1)} style={{ cursor: 'pointer' }} alt="right1" />}
          {rightIcon2 &&<img className="header-right-icon" src={iconMap[rightIcon2]} onClick={()=>handleIconClick(rightIcon2)} style={{ cursor: 'pointer' }} alt="right2" />}
          <img className="header-right-icon" src="/my.svg" onClick={handleMyPage} style={{ cursor: 'pointer' }} alt="my" />
        </div>

        {isOpen && (
        <>
            <div className = "click-menu-container" onClick={profile ? logOut : ()=>navigate('/login')}>
              <div className = "click-menu">
                {profile ? "Log out" : "Log in"}
              </div>
            </div>
        </>)}

      </div>
    </div>
);
}
export default Header;
